import request from "../utils/request";

export const list = () => (data) => request.get("/api/business", data);
